// extracted by css-extract-rspack-plugin
export default {"cls1":"UserSentimentPopup-cls1_rta","cls2":"UserSentimentPopup-cls2_ydL UserSentimentPopup-cls1_rta"};